import { render, staticRenderFns } from "./NotificationWidget.vue?vue&type=template&id=edb753aa&scoped=true&"
import script from "./NotificationWidget.vue?vue&type=script&lang=ts&"
export * from "./NotificationWidget.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationWidget.vue?vue&type=style&index=0&id=edb753aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb753aa",
  null
  
)

export default component.exports